<template>
	<div class="container">
		<div class="top_2">
			<img src="@/assets/ic_success.png" class="ic_success" />
			<span style="font-size: 17px;">此二维码已经通过安全验证，请放心扫码</span>
		</div>

		<div class="top_3">
			<div style="display: flex;align-items: center;">
				<div class="yuanquan1"><img src="@/assets/duigou.png" class="duigou" /></div>
				<div style="font-weight: 600;">支付成功</div>
			</div>
			<div style="color: #1ddad9; margin: 0 15px;">--------</div>
			<div style="display: flex;align-items: center;">
				<div class="yuanquan2">2</div>
				<div style="font-weight: 600;">扫码学习</div>
			</div>
		</div>

		<div class="contents">
			<div style="padding-top: 30px;font-weight: bold;text-align: center;">
				<div style="font-size: 28px;margin-bottom: 5px;">请务必添加二维码上课</div>
				<div style="font-size: 36px;">否则无法正常学习</div>
			</div>
			<div class="info-sum">
				<!-- <img :src="qrcode" style="width: 140px;" /> -->
				<div v-if="qrcode">
					<img :src="qrcode" id="imgCode" draggable="false"
						style="width: 230px;margin-bottom: 20px;border: 1px solid #f3f3f3;padding: 10px;border-radius: 8px;background-color: #f5f5f5;" />
				</div>

				<div style="display: flex;align-items: center;justify-content: center;padding-bottom: 20px;">
					<div style="display: flex;align-items: center;">
						<img src="@/assets/shangjiantou.png" class="shangjiantou" />
						<img src="@/assets/shangjiantou.png" class="shangjiantou" />
						<img src="@/assets/shangjiantou.png" class="shangjiantou" />
					</div>
					<div style="font-size: 18px;padding: 0 5px;font-weight: 600;">长按识别二维码</div>
					<div style="display: flex;align-items: center;">
						<img src="@/assets/shangjiantou.png" class="shangjiantou" />
						<img src="@/assets/shangjiantou.png" class="shangjiantou" />
						<img src="@/assets/shangjiantou.png" class="shangjiantou" />
					</div>
				</div>

				<div style="border-top: 1px dashed #edeef0;padding-top: 20px;">
					<div style="font-size: 18px;padding-bottom: 10px;font-weight: 600;">特别说明</div>
					<div style="color: #999;font-size: 16px;padding-bottom: 5px;">老师会在14:00-22:00通过好友申请，请耐心等候;</div>
					<div style="color: #999;font-size: 16px;">如无法添加二维码请切换网络重新尝试或微信搜索【学小成】</div>
				</div>

				<!-- <img src="@/assets/answering.png" class="answering" /> -->
			</div>
		</div>

		<!-- 覆盖层容器 -->
		<div class="qr-container">
			<!-- 透明二维码图片 -->
			<img :src="qrcode" class="transparent-qr" alt="二维码" id="imgCode" draggable="false">
		</div>
		 
	</div>
</template>

<script>
var that;
import { Toast } from 'vant';
export default {
	name: 'LoginIndex',
	components: {},
	props: {},
	data() {
		return {
			userId: '',
			orderId: '',
			qrcode: '',
		}
	},
	computed: {},
	watch: {},
	created() {
		that = this;
		document.title = '报名成功';
		that.orderId = this.$route.query.orderId || '';
		that.token = this.$route.query.token;//3e560ba8d0f54e3596275ba12023eed6
		if (that.token) {
			localStorage.setItem('token', that.token)
		}
		setTimeout(() => {
			that.getUsers()
		}, 200);
		document.addEventListener('DOMContentLoaded', function () {
			const img = document.getElementById('imgCode');
			img.addEventListener('touchstart', function (e) {
				e.preventDefault();
			})
		})
	},
	methods: {
		getUsers() {
			this.$http.get('/app/users/current', {}).then(res => {
				this.userId = res.data.id;
				this.qrcode = res.data.teacher.qrcode; 
			})
		}, 
 
	}
}
</script>

<style scoped lang="less">
.qr-container {
	position: absolute;
	/* 覆盖目标区域（示例为全屏） */
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	/* 防止遮挡交互 */
	pointer-events: none;
}

.transparent-qr {
	/* 完全透明 */
	opacity: 0;
	/* 图片填充容器 */
	width: 100%;
	height: 100%;
	/* 允许长按触发识别 */
	pointer-events: auto;
}

.shangjiantou {
	width: 40px;
	margin: -8px;
	padding-bottom: 4px;
}

.top_3 {
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 30px;
	padding: 30px;
	background-color: #fff;
	border-radius: 30px;

	.yuanquan1 {
		width: 36px;
		height: 36px;
		border-radius: 50px;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: #1ddad9;
		margin-right: 10px;

		.duigou {
			width: 20px;
			display: block;
		}
	}

	.yuanquan2 {
		width: 36px;
		height: 36px;
		border-radius: 50px;
		line-height: 36px;
		text-align: center;
		border: 2px solid #1ddad9;
		color: #1ddad9;
		margin-right: 10px;
	}

	.ic_success {
		width: 36px;
		height: 36px;
		margin-right: 10px;
		display: block;
	}
}

.top_2 {
	background-color: #d6fdec;
	color: #10a15c;
	display: flex;
	align-items: center;
	justify-content: center;
	font-weight: 500;
	padding: 10px 0;

	.ic_success {
		width: 36px;
		height: 36px;
		margin-right: 10px;
	}
}

 
 
.container {
	font-size: 28px;
	color: #333;
	background: #22d5ff;
	height: 102vh;

	.contents {
		margin: 30px;
		position: relative;
		border-radius: 30px;
		background: #fff;
	}

	.add-teacher {
		width: 100vw;
		// height: 370px;
	}

	.info {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		background: #fff7ed;
		border-radius: 40px 40px 0 0;
		height: 214px;

		.tip {
			font-size: 30px;
		}

		.success {
			width: 80px;
			height: 80px;
			margin-bottom: 16px;
		}
	}

	.info-sum {
		padding: 40px;
		background: #fff;
		border-radius: 0 0 40px 40px;
		// height: 654px;
		display: flex;
		flex-direction: column;
		// justify-content: center;
		align-items: center;

		.answering {
			width: 620px;
			// height: 220px;
		}

		.activation {
			font-size: 32px;
			font-weight: 700;
			padding: 66px 0 40px;
			text-align: center;
		}

		.add {
			width: 622px;
			height: 100px;
			background: #fb0;
			border-radius: 50px;
			display: block;
			line-height: 100px;
			text-align: center;
			font-size: 40px;
			color: #fff;
			font-weight: 700;
			outline: none;
			margin-bottom: 107px;
			-webkit-animation: fadenum 0.8s ease infinite;
			animation: fadenum 0.8s ease infinite;
		}
	}
}

@keyframes fadenum {
	0% {
		transform: scale(0.95);
		-webkit-transform: scale(0.95);
	}

	50% {
		transform: scale(1.02);
		-webkit-transform: scale(1.02);
	}

	100% {
		transform: scale(0.95);
		-webkit-transform: scale(0.95);
	}
}

* {

	-webkit-touch-callout: none;
	/*系统默认菜单被禁用*/

	-webkit-user-select: none;
	/*webkit浏览器*/

	-khtml-user-select: none;
	/*早期浏览器*/

	-moz-user-select: none;
	/*火狐*/

	-ms-user-select: none;
	/*IE10*/

	user-select: none;

}
</style>